import classes from "./LanguageSwitcher.module.css";
import NorwayFlag from "../../images/NorwayFlag.svg";
import EnglishFlag from "../../images/EnglishFlag.svg";
import { setLanguage } from "../../redux/globalFunctions/globalFnSlice";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { resetPackageForm } from "../../redux/forms/packageForm";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";

export function LanguageSwitcher() {
  const { language } = useSelector((state) => state.global);
  const dispatch = useDispatch();
  const [showAltFlag, setShowAltFlag] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef(null);

  const { t } = useTranslations();
  const text = t.languageSwitcher;

  const flags = [
    { code: "no", src: NorwayFlag, alt: "Norway Flag", text: text.no },
    { code: "en", src: EnglishFlag, alt: "English Flag", text: text.en },
  ];

  const handleSelectedClick = () => {
    setIsVisible(true);
    requestAnimationFrame(() => setShowAltFlag((prev) => !prev));
  };

  const handleAltClick = (lang) => {
    dispatch(resetPackageForm());
    dispatch(setLanguage(lang));
    // Immediately close the alt flags
    setShowAltFlag(false);
    setIsVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowAltFlag(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleTransitionEnd = () => {
    if (!showAltFlag) setIsVisible(false);
  };

  // Find the selected flag
  const selectedFlag = flags.find((f) => f.code === language);
  // Flags to show as alternatives
  const altFlags = flags.filter((f) => f.code !== language);

  return (
    <div className={classes.flags} ref={wrapperRef}>
      <div className={classes.flagWrapper} onClick={handleSelectedClick}>
        <img
          src={selectedFlag.src}
          alt={selectedFlag.alt}
          className={classes.flag}
        />
      </div>

      {isVisible && (
        <div
          className={classes.altFlags}
          style={{
            opacity: showAltFlag ? 1 : 0,
            transition: "opacity 0.3s ease-out",
          }}
          onTransitionEnd={handleTransitionEnd}
        >
          {altFlags.map((flag) => (
            <div
              key={flag.code}
              className={classes.altFlag}
              onClick={() => handleAltClick(flag.code)}
            >
              <img src={flag.src} alt={flag.alt} />
              <p>{flag.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
